import { render } from "./BotonPrimario.vue?vue&type=template&id=5e3969ec&scoped=true&ts=true"
import script from "./BotonPrimario.vue?vue&type=script&lang=ts"
export * from "./BotonPrimario.vue?vue&type=script&lang=ts"

import "./BotonPrimario.vue?vue&type=style&index=0&id=5e3969ec&lang=scss&scoped=true"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3969ec"]])

export default __exports__